import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { toast } from 'sonner';

export const resendForgotPasswordOTPAPI = async (email: string, locationId: string) => {
  const response = await baseAPI.post<unknown>(`/users/resend-forgot-password-otp`, {
    email: email,
    locationId: locationId,
  });
  return response.data;
};

export const useResendForgotPasswordOTP = () => {
  return useMutation({
    mutationFn: ({email, locationId}: {email: string, locationId: string}) => resendForgotPasswordOTPAPI(email, locationId),
    onSuccess: (_data) => {
        toast.success('OTP resent successfully');
    },
    onError: (error: Error) => {
        toast.error(error.message);
    },
  });
};

